// removed by extract-text-webpack-plugin
module.exports = {"component":"MedicineGuideItem__component___3GfzJ","element":"MedicineGuideItem__element___2YCV3","elementOpen":"MedicineGuideItem__elementOpen___30CWd","text":"MedicineGuideItem__text___3SRzo"};


//////////////////
// WEBPACK FOOTER
// ./src/homepage/components/MedicineGuideItem.css
// module id = 173
// module chunks = 0